import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(ejecutarFuncion),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(goto),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(zona),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchZona);

import { takeEvery, select, put, call } from 'redux-saga/effects';
import { ZONA, ejecutarFuncion as ejecutarFuncionAction } from '../actions';
import { getZona } from '../selectors/config-paginas';
import { getIdByNum, getNumPaginaIzquierda, getPaginasPorPantalla } from '../selectors/config-libro';
import { getConfigGeneral, getPantallaProps } from '../selectors';
import { tipoVinculo } from '../util';
import { pantalla } from '../actions';
import { PANTALLA_VENTANA_ID, PANTALLA_LIBRO_ID } from '../constantes';

function ejecutarFuncion(libroId, numPagina, numZona, zona) {
  var _zona$vinculo$split, funcion, _funcion$split, nombre, params;

  return _regeneratorRuntime.wrap(function ejecutarFuncion$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _zona$vinculo$split = zona.vinculo.split(","), funcion = _zona$vinculo$split[1];
          _funcion$split = funcion.split(":"), nombre = _funcion$split[0], params = _funcion$split[1]; // window.console.log("watch-zona ejecutarFuncion libroId, numPagina, numZona, zona, nombre, params", libroId, numPagina, numZona, nombre, params)

          _context.next = 4;
          return put(ejecutarFuncionAction(libroId, numPagina, numZona, nombre, params));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function goto(zona) {
  var params, numLibro, _numPagina, libroId, numPagina;

  return _regeneratorRuntime.wrap(function goto$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          params = zona.vinculo.split(',');

          if (!(params.length === 3)) {
            _context2.next = 12;
            break;
          }

          if (!(params[1].length === 5)) {
            _context2.next = 5;
            break;
          }

          return _context2.delegateYield(ejecutarFuncionAction('abrirZona', params[1] + '.' + params[2]), 't0', 4);

        case 4:
          return _context2.abrupt('return');

        case 5:
          //
          // Ir a pagina de otro libro
          //
          numLibro = params[1], _numPagina = params[2];
          _context2.next = 8;
          return select(getIdByNum, numLibro);

        case 8:
          libroId = _context2.sent;
          _context2.next = 11;
          return put(pantalla(PANTALLA_LIBRO_ID, {
            libroId: libroId,
            numPagina: Number(_numPagina)
          }));

        case 11:
          return _context2.abrupt('return');

        case 12:
          //
          // Ir a pagina del mismo libro
          //
          numPagina = params[1];
          _context2.next = 15;
          return put(pantalla(PANTALLA_LIBRO_ID, {
            numPagina: Number(numPagina)
          }));

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function zona(_ref) {
  var libroId = _ref.libroId,
      numPagina = _ref.numPagina,
      numZona = _ref.numZona;

  var zona, configGeneral, _ref2, libroIdZonaNotas, numPaginaZonaNotas, numZonaZonaNotas, libroIdGuardado, numPaginaGuardado, numZonaGuardado, pantallaProps, paginasPorPantalla;

  return _regeneratorRuntime.wrap(function zona$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(getZona, libroId, numPagina, numZona);

        case 2:
          zona = _context3.sent;
          _context3.next = 5;
          return select(getConfigGeneral);

        case 5:
          configGeneral = _context3.sent;
          _ref2 = configGeneral.zonaNotas || {
            libroIdZonaNotas: 'SB',
            numPaginaZonaNotas: 500,
            numZonaZonaNotas: 1
          }, libroIdZonaNotas = _ref2.libroIdZonaNotas, numPaginaZonaNotas = _ref2.numPaginaZonaNotas, numZonaZonaNotas = _ref2.numZonaZonaNotas;
          libroIdGuardado = libroId;
          numPaginaGuardado = numPagina;
          numZonaGuardado = numZona;

          if (!(libroId === libroIdZonaNotas && numPagina === numPaginaZonaNotas && numZona === numZonaZonaNotas)) {
            _context3.next = 26;
            break;
          }

          _context3.next = 13;
          return select(getPantallaProps);

        case 13:
          pantallaProps = _context3.sent;
          libroIdGuardado = pantallaProps.libroId;
          _context3.next = 17;
          return select(getPaginasPorPantalla, libroId);

        case 17:
          paginasPorPantalla = _context3.sent;

          if (!(paginasPorPantalla === 1)) {
            _context3.next = 22;
            break;
          }

          numPaginaGuardado = pantallaProps.numPagina;
          _context3.next = 25;
          break;

        case 22:
          _context3.next = 24;
          return select(getNumPaginaIzquierda, libroIdGuardado, pantallaProps.numPagina);

        case 24:
          numPaginaGuardado = _context3.sent;

        case 25:
          numZonaGuardado = 999;

        case 26:
          _context3.t0 = tipoVinculo(zona);
          _context3.next = _context3.t0 === 'goto' ? 29 : _context3.t0 === 'funcion' ? 32 : 35;
          break;

        case 29:
          _context3.next = 31;
          return call(goto, zona);

        case 31:
          return _context3.abrupt('break', 38);

        case 32:
          _context3.next = 34;
          return call(ejecutarFuncion, libroId, numPagina, numZona, zona);

        case 34:
          return _context3.abrupt('break', 38);

        case 35:
          _context3.next = 37;
          return put(pantalla(PANTALLA_VENTANA_ID, {
            libroId: libroId,
            numPagina: numPagina,
            numZona: numZona,
            libroIdGuardado: libroIdGuardado,
            numPaginaGuardado: numPaginaGuardado,
            numZonaGuardado: numZonaGuardado
          }));

        case 37:
          return _context3.abrupt('break', 38);

        case 38:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function watchZona() {
  return _regeneratorRuntime.wrap(function watchZona$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeEvery(ZONA, zona);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

export default watchZona;